import { render, staticRenderFns } from "./ArtigosComoFunciona.vue?vue&type=template&id=1adf3177&scoped=true&"
import script from "./ArtigosComoFunciona.vue?vue&type=script&lang=js&"
export * from "./ArtigosComoFunciona.vue?vue&type=script&lang=js&"
import style0 from "./ArtigosComoFunciona.vue?vue&type=style&index=0&id=1adf3177&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adf3177",
  null
  
)

export default component.exports